import { render } from "./LesAanbodView.vue?vue&type=template&id=256ae737&scoped=true"
import script from "./LesAanbodView.vue?vue&type=script&lang=js"
export * from "./LesAanbodView.vue?vue&type=script&lang=js"

import "./LesAanbodView.vue?vue&type=style&index=0&id=256ae737&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-256ae737"]])

export default __exports__